import { MouseEvent, memo } from 'react';
import { DropDownOption } from 'src/types';
import { Radio } from '../Radio';

interface RadioGroupProps {
  name?: string;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
  options?: DropDownOption[];
  checkValue?: string;
}

const _RadioGroup = ({ name, onClick, options = [], checkValue }: RadioGroupProps) => {
  return (
    <div className="flex gap-7 w-full flex-wrap" onClick={onClick}>
      {options.map((option) => (
        <Radio
          name={name}
          key={option.id}
          value={option.id}
          label={option.name}
          checked={checkValue === option.id}
        />
      ))}
    </div>
  );
};

export const RadioGroup = memo(_RadioGroup);
